var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailFormIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.566 0.5H1.76602C0.883616 0.5 0.166016 1.328 0.166016 2.34615V10.6538C0.166016 11.672 0.883616 12.5 1.76602 12.5H14.566C15.4484 12.5 16.166 11.672 16.166 10.6538V2.34615C16.166 1.328 15.4484 0.5 14.566 0.5ZM13.0564 2.34615L8.16602 5.87231L3.27562 2.34615H13.0564ZM1.76602 10.6538V3.43446L7.74202 7.74431C7.87162 7.83754 8.01882 7.88462 8.16602 7.88462C8.31322 7.88462 8.46042 7.83754 8.59002 7.74431L14.566 3.43354L14.5668 10.6538H1.76602Z",
    fill: "#C2C2C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailFormIcon);
export default __webpack_public_path__ + "static/media/EmailFormIcon.516d2f7689ef8b4255e05a39777f5820.svg";
export { ForwardRef as ReactComponent };